<template>
  <div class="wp-body" style="padding-bottom:30px;" v-if="!loading" v-loading.fullscreen.lock="loading"
    :element-loading-text="$t('connecting')" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <header class="wp-header">
      <div class="flex flex-wrap flex-1 gap-2">
        <div v-if="['admin', 'ministry', 'ministry_admin', 'main_org_admin', 'supervisor'].includes(me.role.name)" class="w-full sm:w-52">
          <el-select class="w-full" :placeholder="$t('region')" v-model="region" @change="regionChanged(); __GET();"
            clearable>
            <el-option v-for="item in regions" :key="item.id"
              :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
              :value="item.shared_id">
            </el-option>
          </el-select>
        </div>
        
        <div v-if="['admin', 'ministry', 'ministry_admin', 'main_org_admin', 'supervisor'].includes(me.role.name)" class="w-full sm:w-52">
          <el-select class="w-full" :placeholder="$t('district')" v-model="district" @change="ChangeDistrict(), __GET()"
            :disabled="!region" clearable>
            <el-option v-for="item in districts" :key="item.id" :label="item[`name_${$i18n.locale}`]
              ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
              
            </el-option>
          </el-select>
        </div>
        <div v-if="['admin', 'ministry', 'org_admin', 'ministry_admin', 'main_org_admin', 'supervisor'].includes(me.role.name)" class="w-full sm:w-52">
          <el-select class="w-full" v-model="buildinggroup" :placeholder="$t('building_category')" @change="__GET()"
            clearable>
            <el-option v-for="item in building_group" :key="item.id" :label="item[`name_${$i18n.locale}`] ?
              item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="w-full sm:w-52">
          <el-input class="search" style="margin-left: 0 !important;" :placeholder="$t('search')"
            prefix-icon="el-icon-search" v-model="search" @keyup.enter.native="__GET()" clearable>
          </el-input>
        </div>
        <div class="w-max">
          <button class="secondary-btn" @click="fetchOptions()"><h-filter-07 class="icon"/> {{ $t('advanced_filter') }}</button>
        </div>
        <div class="flex-1"></div>
        <div class="w-max">
          <button v-if="['admin'].includes(role) && ['exg', 'new'].includes($route.params.type)" class="secondary-btn"
            :disabled="loading_generate" @click="generate_building_list()">
            {{ $t('download') }}
            <h-loading v-if="loading_generate" class="spin icon"/>
            <h-file-download v-else class="icon"/>
          </button>
        </div>
      </div>
      <button
        v-if="role !== 'admin' && (role === 'operator' && role !== 'org_admin' && role !== 'ministry_admin' && role !== 'main_org_admin' && $route.params.type != 'new')"
        class="add__button" @click="$router.push({ name: 'add-build', params: { id: $route.params.id || 'create'  } })">
        {{ $t('exist_building_add') }} <HAddCircle/>
      </button>
      <button
        v-if="role !== 'admin' && (role === 'ministry' && role !== 'org_admin' && role !== 'ministry_admin' && role !== 'main_org_admin' && $route.params.type == 'new')"
        class="add__button" @click="$router.push({ name: 'add-build', params: { id: $route.params.id || 'create' } })">
        {{ $t('new_building_add') }} <HAddCircle/>
      </button>
    </header>
    <el-table :data="buildsList" class="mt-5 fs-14" style="width: 99%; margin-bottom: 20px" row-key="id"
      :row-class-name="tableRowClassName">
      <el-table-column label="№" width="100px" align="center">
        <template slot-scope="scope">
          {{ (current_page - 1) * item_count + (scope.$index + 1) }}
        </template>
      </el-table-column>
      <el-table-column prop="cadastral_number" :label="$t('cadaster_number').toUpperCase()" width="230" sortable>
        <template slot-scope="scope">
          <p @click="routeTo(scope.row, 0)" class="cursor-pointer rounded-lg py-1 px-3 bg-indigo-50 font-bold text-indigo-800 leading-snug w-max">{{
            scope.row.cadastral_number }}</p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('building_name').toUpperCase()" width="300" sortable>
        <template slot-scope="scope">
          <p @click="routeTo(scope.row, 0)" class="table-link-button">
            {{ scope.row.name_cyr ? scope.row.name_cyr : "***" }}
            
          </p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('building_catagory').toUpperCase()" prop="building_group.name_cyr" min-width="250"
        sortable>
      </el-table-column>
      <el-table-column :label="$t('created_at').toUpperCase()" width="152" prop="created_at" sortable>
      </el-table-column>
      <el-table-column :label="$t('year_construction').toUpperCase()" width="120" prop="year_construction" sortable>
      </el-table-column>
      <el-table-column width="110px" class="p0" prop="finalconclusion" :label="$t('finalconclusion').toUpperCase()"
        sortable>
        <template slot-scope="scope">
          <p class="finalconclusion" :class="`fc__bg-${scope.row.finalconclusion}`">
            {{ scope.row.finalconclusion }}
          </p>
        </template>
      </el-table-column>
      <el-table-column v-if="$route.path !== '/building-list/new'" :label="$t('investment_project').toUpperCase()"
        prop="is_invest" width="125px">
        <template slot-scope="scope">
          <InvestmentSwitch v-if="scope.row.is_invest" v-model="scope.row.is_invest" :id="scope.row.id" :disabled="role != 'operator'" />
          <p v-else class="bg-indigo-50 py-1 px-3.5 rounded-lg font-semibold text-sm leading-snug w-max">{{ $t('Кирмаган') }}</p>
        </template>
      </el-table-column>
      <el-table-column v-if="$route.params.type !== 'newcadaster'" width="190px" :label="$t('created_by').toUpperCase()"
       sortable>
        <template slot-scope="scope">
          <div class="table-link-button py-1 px-2.5 flex items-center gap-1 bg-slate-100 hover:bg-slate-200 rounded-md" @click="UserModal(scope.row.created_by)">
            {{
            scope.row.created_by != null &&
            scope.row.created_by.profile != null
            ? scope.row.created_by.profile.name +
            " " +
            scope.row.created_by.profile.surname
            : "-"
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="$route.params.type !== 'newcadaster'" :label="$t('updated_by').toUpperCase()"
         sortable min-width="190px">
        <template slot-scope="scope">
          <div class="table-link-button py-1 px-2.5 flex items-center gap-1 bg-slate-100 hover:bg-slate-200 rounded-md" @click="UserModal(scope.row.updated_by)">
            {{
            scope.row.updated_by != null &&
            scope.row.updated_by.profile != null
            ? scope.row.updated_by.profile.name +
            " " +
            scope.row.updated_by.profile.surname
            : "-"
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="['operator', 'org_admin', 'ministry_admin', 'ministry', 'main_org_admin'].includes(role)"
        label="Кадастр рақамни янгилаш" width="180" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.updating_cadastr && scope.row.cadastr_list && scope.row.cadastr_list.length"
            class="flex justify-center">
            <button class="px-3 py-2 bg-purple-600 text-white rounded-xl text-xs font-bold"
              @click="setNewCadasterFrom(scope.row)">Янгилаш</button>
          </div>
          <div v-else class="test-green-600 font-bold text-green-600">
            Ўзгармаган
          </div>
        </template>
      </el-table-column>
      <el-table-column width="164"  :label="$t('actions').toUpperCase()" v-if="
          role !== 'ministry_admin' &&
          role !== 'main_org_admin' &&
          !(role == 'operator' && $route.params.type == 'new')
        ">
        <template slot-scope="scope">
          <div class="flex items-center gap-2">
            <button v-if="$route.params.type !== 'newcadaster' && role == 'admin'"
              type="button"
              class="w-10 h-10 bg-indigo-50 hover:bg-indigo-100 text-indigo-800 rounded-xl flex items-center justify-center"
              @click="GeneratePasport(scope.row.id)">
              <h-document-text/>
            </button>
            <button v-if="$route.params.type !== 'newcadaster'" @click="DownloadExel(scope.row.id, scope.row.name_cyr)"
              type="button" class="w-10 h-10 bg-slate-100 hover:bg-slate-200 text-indigo-800 rounded-xl flex items-center justify-center">
              <h-file-download/>
            </button>
            <button @click="routeTo(scope.row, 1)"
              type="button" class="w-10 h-10 bg-slate-100 hover:bg-slate-200 text-indigo-800 rounded-xl flex items-center justify-center">
              <h-eye v-if="role === 'supervisor'"/>
              <h-edit v-else/>
            </button>
            <button v-if="role == 'operator' && false" @click="deleteBuilding(scope.row.id)"
              type="button" class="w-10 h-10 bg-rose-50 hover:bg-rose-200 text-rose-600 rounded-xl flex items-center justify-center">
              <h-trash/>
            </button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin-left: auto; margin-top: auto" class="ml-auto" :page-sizes="[10, 20, 50, 100]"
      :page-size="5" @current-change="paginate" @size-change="paginateSize" :current-page.sync="current_page1"
      :hide-on-single-page="false" background layout="sizes, prev, pager, next" :page-count="page_count" :total="null">
    </el-pagination>

    <el-drawer :title="$t('building_passport')" :visible.sync="drawer" direction="rtl">
      <div>
        <div class="pdf">
          <vue-pdf ref="print" :src="pdf"></vue-pdf>
          <div class="loading-pdf" v-show="loadDawer">
            <i class="el-icon-loading"></i>
          </div>
        </div>
        <div class="w-full pdf-control">
          <a :href="pdf" target="_blank">
            <button class="bg-indigo-50 hover:bg-indigo-100  h-10 px-4 rounded-xl flex items-center gap-2 font-semibold text-slate-800 mr-2">
              {{ $t("see") }} <HEye class="text-indigo-800"/>
            </button>
          </a>
          <button class="bg-indigo-800 hover:bg-indigo-700 h-10 px-4 rounded-xl flex items-center gap-2 font-semibold text-white" @click="downloadFile(pdf)">
            {{ $t("download") }} <HFileDownload/>
          </button>
        </div>
      </div>
    </el-drawer>
        <div class="modal fs-14" v-if="usermodal">
            <div class="modal-cover"></div>
                <div class="modal-item p-3 sm:p-7 pt-0" style="max-width:664px; ">
                    <div class="flex justify-between items-center py-7">
                        <p class="modal-title text-slate-950" style="margin: 0; font-size: 24px; line-height: 33px; font-weight: 700; ">{{$t('user_date')}}:</p>
                        <button class="bg-slate-100 rounded-xl p-2 text-indigo-900" @click="usermodal=false">
                            <h-remove-circle/>
                        </button>
                    </div>
                    <div class="flex flex-wrap -my-1 sm:-my-2.5 -mx-1">
                        <div class="w-full py-1 sm:py-2.5 px-1">
                            <div class="flex gap-3 items-center bg-slate-50 px-3 py-2 rounded-xl">
                                <div>
                                    <h-user class="w-6 h-6 sm:w-8 sm:h-8 text-cyan-600"/>
                                </div>
                                <div class="flex flex-wrap gap-5">
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('last_name')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.profile.surname }}</p>
                                    </div>
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('first_name')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.profile.name }}</p>
                                    </div>
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('mid_name')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.profile.middlename }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-full py-1 sm:py-2.5 px-1">
                            <div class="flex gap-3 items-center bg-slate-50 px-3 py-2 rounded-xl">
                                <div>
                                    <h-home class="w-6 h-6 sm:w-8 sm:h-8 text-cyan-600"/>
                                </div>
                                <div class="flex gap-5">
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('organisation_name')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.organization && userData.organization.name_cyr ? userData.organization.name_cyr : '-' }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-full sm:w-1/2  py-1 sm:py-2.5 px-1">
                            <div class="flex gap-3 items-center bg-slate-50 px-3 py-2 rounded-xl">
                                <div>
                                    <h-call class="w-6 h-6 sm:w-8 sm:h-8 text-cyan-600"/>
                                </div>
                                <div class="flex gap-5">
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('phone_munber')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.profile.phone_number }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-full sm:w-1/2  py-1 sm:py-2.5 px-1">
                            <div class="flex gap-3 items-center bg-slate-50 px-3 py-2 rounded-xl">
                                <div>
                                    <h-mail class="w-6 h-6 sm:w-8 sm:h-8 text-cyan-600"/>
                                </div>
                                <div class="flex gap-5">
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('user_email')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.profile.email ? userData.profile.email : '-' }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

    <BuildingUpgradeCadasterVue v-model="newCadastrModal" :buildingInfo="newCasasterForm" @changed="__GET()" />


    <!-- FILTERS -->
    <el-dialog class="advanced-filter-dialog" :title="$t('advanced_filter_long')" :visible.sync="dialogVisible" width="min(1456px, 95%)"
      style="margin-left: 10px;" :show-close="false">
      <template slot="title">
        <div class="flex items-center justify-between">
          <h1 class="text-xl sm:text-2xl font-bold">{{$t('advanced_filter_long')}}</h1>
          <button class="bg-slate-100 rounded-xl p-2 text-indigo-900" @click="dialogVisible = false">
            <h-remove-circle/>
          </button>
        </div>
      </template>
      <div class="-mx-4 sm:mx-0 p-4 rounded-2xl bg-cool-50 mb-5">
        <div class="flex items-center gap-2 mb-5">
          <icon-building-4 class="w-6 h-6 text-cyan-600"/>
          <h1 class="font-bold text-base sm:text-xl text-slate-950">{{ $t('transport_general_info') }}</h1>
        </div>
        <div class="flex flex-wrap -m-1.5">
          <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
            <label class="block font-medium text-sm mb-2">
              {{ $t('cadaster_number') }}
            </label>
            <el-input
              v-model="selectedOptions.cadastral_number"
              :placeholder="`${$t('example')}: 10:01:01:01:01:1111`"
              clearable
            />
          </div>
          <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
            <label class="block font-medium text-sm mb-2">
              {{ $t('name') }}
            </label>
            <el-input
              v-model="selectedOptions[`name_${$i18n.locale}`]"
              :placeholder="$t('name')"
              clearable
            />
          </div>
          <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
            <label class="block font-medium text-sm mb-2">
              {{ $t('year_construction') }}
            </label>
            <el-date-picker 
              v-model="selectedOptions.year_construction"
              :placeholder="$t('year_of_construction')" 
              type="year" 
              value-format="yyyy" 
              style="width: 100%;"
              >
            </el-date-picker>
          </div>
          <div class="p-1.5 w-full sm:w-1/2 lg:w-1/4">
            <label class="block font-medium text-sm mb-2">
              {{ $t('region') }}
            </label>
            <el-select 
              class="w-full" 
              :placeholder="$t('region')" 
              v-model="region" 
              @change="getDistrict(), district = ''"
              clearable>
              <el-option v-for="item in regions" :key="item.id"
                :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                :value="item.shared_id">
              </el-option>
            </el-select>
          </div>
          <div class="p-1.5 w-full sm:w-1/2 lg:w-1/4">
            <label class="block font-medium text-sm mb-2">
              {{ $t('district') }}
            </label>
            <el-select 
              class="w-full" 
              :placeholder="$t('district')" 
              v-model="district" 
              @change="getNeighborhoods()"
              :disabled="!region" clearable>
              <el-option v-for="item in districts" :key="item.id" :label="item[`name_${$i18n.locale}`]
                ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="p-1.5 w-full sm:w-1/2 lg:w-1/4">
            <label class="block font-medium text-sm mb-2">
              {{ $t('neighborhood') }}
            </label>
            <el-select 
              class="w-full" 
              :placeholder="$t('neighborhood')" 
              v-model="neighborhood"
              :disabled="!region" clearable>
              <el-option v-for="item in neighborhoods" :key="item.id" :label="item[`name_${$i18n.locale}`]
                ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="p-1.5 w-full sm:w-1/2 lg:w-1/4">
            <label class="block font-medium text-sm mb-2">
              {{ $t('address') }}
            </label>
            <el-input
              v-model="selectedOptions.address"
              :placeholder="$t('address')"
              clearable
            />
          </div>
          <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
            <label class="block font-medium text-sm mb-2">
              {{ $t('floor_count') }}
            </label>
            <el-input
              v-model="selectedOptions.numberfloors"
              type="number"
              :placeholder="$t('floor_count')"
              clearable
            />
          </div>
          <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
            <label class="block font-medium text-sm mb-2">
              {{ $t('building_category') }}
            </label>
            <el-select class="w-full" v-model="buildinggroup" :placeholder="$t('building_category')"
              clearable>
              <el-option v-for="item in building_group" :key="item.id" :label="item[`name_${$i18n.locale}`] ?
                item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
              </el-option>
            </el-select>
          </div>

        </div>
      </div>
      <div class=" -mx-4 sm:mx-0 p-4 rounded-2xl bg-cool-50 filter">
        <el-collapse class="mb-5">
          <el-collapse-item name="1">
            <template slot="title">
              <div class="flex items-center gap-2">
                <h-compass class="w-6 h-6 text-cyan-600"/>
                <h1 class="font-bold text-base sm:text-xl truncate">{{ $t('technical_information') }}</h1>
              </div>
            </template>
            <div class="bg-white p-4" style="border-radius: 20px;">
              <div class="flex flex-wrap -m-1.5">
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('transport_seismicity_construction_site') }}
                  </label>
                  <el-select v-model="selectedOptions.buildingseismicity" class="w-full"
                    :placeholder="$t('transport_seismicity_construction_site')" clearable>
                    <el-option v-for="item in options[2]" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('floors_height') }}
                  </label>
                  <el-input
                    v-model="selectedOptions.floors_height"
                    type="number"
                    :placeholder="$t('floors_height')"
                    clearable
                  />
                </div>
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('foundation_type') }}
                  </label>
                  <el-select 
                  class="w-full" 
                  :placeholder="$t('foundation_type')" 
                  v-model="selectedOptions.foundation_type"
                  clearable>
                  <el-option v-for="item in dictionary.foundationtype" :key="item.id" :label="item[`name_${$i18n.locale}`]
                      ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('constructive_solution') }}
                  </label>
                  <el-select v-model="selectedOptions.constructivesolution" class="w-full"
                    :placeholder="$t('constructive_solution')" clearable>
                    <el-option v-for="item in options[0]" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('part_attic') }}
                  </label>
                  <el-input
                    v-model="selectedOptions.part_attic"
                    type="number"
                    :placeholder="$t('part_attic')"
                    clearable
                  />
                </div>
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('loadbearingstatus_input') }}
                  </label>
                  <el-select 
                  class="w-full" 
                  :placeholder="$t('loadbearingstatus_input')" 
                  v-model="selectedOptions.loadbearing"
                  clearable>
                  <el-option v-for="item in dictionary.loadbearing" :key="item.id" :label="item[`name_${$i18n.locale}`]
                      ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('plannedshape') }}
                  </label>
                  <el-select 
                  class="w-full" 
                  :placeholder="$t('plannedshape')" 
                  v-model="selectedOptions.plannedshape"
                  clearable>
                  <el-option v-for="item in dictionary.plannedshape" :key="item.id" :label="item[`name_${$i18n.locale}`]
                      ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('technical_height') }}
                  </label>
                  <el-input
                    v-model="selectedOptions.technical_height"
                    type="number"
                    :placeholder="$t('technical_height')"
                    clearable
                  />
              </div>
              <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                <label class="block font-medium text-sm mb-2">
                  {{ $t('coverings') }}
                </label>
                <el-select 
                class="w-full" 
                :placeholder="$t('coverings')" 
                v-model="selectedOptions.coverings"
                clearable>
                <el-option v-for="item in dictionary.coverings" :key="item.id" :label="item[`name_${$i18n.locale}`]
                    ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                <label class="block font-medium text-sm mb-2">
                  {{ $t('dimensional_parameters') }}
                </label>
                <div class="flex items-center justify-between gap-1.5">
                  <el-input
                  v-model="selectedOptions.length"
                  type="number"
                  :placeholder="$t('transport_length')"
                  clearable
                  />
                  <el-input
                  v-model="selectedOptions.width"
                  type="number"
                  :placeholder="$t('width')"
                  clearable
                  />
                  <el-input
                  v-model="selectedOptions.height"
                  type="number"
                  :placeholder="$t('height')"
                  clearable
                  />
                </div>
              </div>
              <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                <label class="block font-medium text-sm mb-2">
                  {{ $t('balance_value') }}
                </label>
                <el-input
                v-model="selectedOptions.balance_value"
                type="number"
                :placeholder="$t('balance_value')"
                clearable
                />
              </div>
              <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                <label class="block font-medium text-sm mb-2">
                  {{ $t('roofsection') }}
                </label>
                <el-select 
                class="w-full" 
                :placeholder="$t('roofsection')" 
                v-model="selectedOptions.roofsection"
                clearable>
                <el-option v-for="item in dictionary.roofsection" :key="item.id" :label="item[`name_${$i18n.locale}`]
                    ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                <label class="block font-medium text-sm mb-2">
                  {{ $t('divided_into_sections_input') }}
                </label>
                <el-select 
                class="w-full" 
                :placeholder="$t('divided_into_sections_input')" 
                v-model="selectedOptions.dividedintosections"
                clearable>
                <el-option v-for="item in dictionary.dividedintosections" :key="item.id" :label="item[`name_${$i18n.locale}`]
                    ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                <label class="block font-medium text-sm mb-2">
                  {{ $t('basement_presence') }}
                </label>
                <el-select 
                class="w-full" 
                :placeholder="$t('basement_presence')" 
                v-model="selectedOptions.basement_presence"
                clearable>
                <el-option v-for="item in dictionary.presence" :key="item.id" :label="item[`name_${$i18n.locale}`]
                    ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                  </el-option>
                </el-select>
              </div>

              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        
        <el-collapse class="mb-5">
          <el-collapse-item name="1">
            <template slot="title">
              <div class="flex items-center gap-2 overflow-hidden">
                <h-sertificate class="w-6 h-6 text-cyan-600"/>
                <div class="w-full overflow-hidden">
                  <h1 class="font-bold text-base sm:text-xl truncate">{{ $t('structural_parameters') }}</h1>
                </div>
              </div>
            </template>
            <div class="bg-white p-4 mb-5" style="border-radius: 20px;">
              <div class="flex flex-wrap -m-1.5">
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('divisions_number') }}
                  </label>
                  <el-input
                    v-model="selectedOptions.divisions_number"
                    type="number"
                    :placeholder="$t('divisions_number')"
                    clearable
                  />
                </div>
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('longitudinal_wall') }}
                  </label>
                  <el-input
                    v-model="selectedOptions.longitudinal_wall"
                    type="number"
                    :placeholder="$t('longitudinal_wall')"
                    clearable
                  />
                </div>
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('window_betwee_length') }}
                  </label>
                  <el-input
                    v-model="selectedOptions.window_spacing"
                    type="number"
                    :placeholder="$t('window_betwee_length')"
                    clearable
                    />
                </div>
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('chok_count') }}
                  </label>
                  <el-input
                    v-model="selectedOptions.section_parameters"
                    type="number"
                    :placeholder="$t('chok_count')"
                    clearable
                    />
                </div>
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('longitudinal_wall_spacing') }}
                  </label>
                  <el-input
                    v-model="selectedOptions.longitudinal_wall_spacing"
                    type="number"
                    :placeholder="$t('longitudinal_wall_spacing')"
                    clearable
                    />
                </div>
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('walls_length') }}
                  </label>
                  <el-input
                    v-model="selectedOptions.curtains"
                    type="number"
                    :placeholder="$t('walls_length')"
                    clearable
                    />
                </div>
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('transverse_wall_step') }}
                  </label>
                  <el-input
                    v-model="selectedOptions.transverse_wall_step"
                    type="number"
                    :placeholder="$t('transverse_wall_step')"
                    clearable
                    />
                </div>
              <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                <label class="block font-medium text-sm mb-2">
                  {{ $t('seismicbelts') }}
                </label>
                <el-select 
                class="w-full" 
                :placeholder="$t('seismicbelts')" 
                v-model="selectedOptions.seismicbelts"
                clearable>
                <el-option v-for="item in dictionary.beltspresence" :key="item.id" :label="item[`name_${$i18n.locale}`]
                    ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                <label class="block font-medium text-sm mb-2">
                  {{ $t('connectingbelts') }}
                </label>
                <el-select 
                class="w-full" 
                :placeholder="$t('connectingbelts')" 
                v-model="selectedOptions.connectingbelts"
                clearable>
                <el-option v-for="item in dictionary.beltspresence" :key="item.id" :label="item[`name_${$i18n.locale}`]
                    ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                  </el-option>
                </el-select>
              </div>
                
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-collapse>
          <el-collapse-item name="1">
            <template slot="title">
              <div class="flex items-center gap-2 overflow-hidden">
                <h-sertificate class="w-6 h-6 text-cyan-600"/>
                <div class="w-full overflow-hidden">
                  <h1 class="font-bold text-base sm:text-xl truncate">{{ $t('material_parameters') }}</h1>
                </div>
              </div>
            </template>
            <div class="bg-white p-4 " style="border-radius: 20px;">
              <div class="flex flex-wrap -m-1.5">
                <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('concrete_class') }}
                  </label>
                  <el-select 
                  class="w-full" 
                  :placeholder="$t('concrete_class')" 
                  v-model="selectedOptions.concrete_class"
                  filterable
                  clearable>
                  <el-option v-for="option in dictionary.concreteclass" :key="option.id" :label="option.name" :value="option.id">
                    </el-option>
                  </el-select>
                </div>
                <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('brick_brand') }}
                  </label>
                  <el-select 
                  class="w-full" 
                  :placeholder="$t('brick_brand')" 
                  v-model="selectedOptions.brick_brand"
                  clearable>
                  <el-option v-for="option in dictionary.brickbrand" :key="option.id" :label="option.name" :value="option.id">
                    </el-option>
                  </el-select>
                </div>
                <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('armature_class_armatureclass') }}
                  </label>
                  <el-select 
                  class="w-full" 
                  :placeholder="$t('armature_class_armatureclass')" 
                  v-model="selectedOptions.armature_class"
                  clearable>
                  <el-option v-for="option in dictionary.armatureclass" :key="option.id" :label="option.name" :value="option.id">
                    </el-option>
                  </el-select>
                </div>
                <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('armature_class_armaturediametr') }}
                  </label>
                  <el-select 
                  class="w-full" 
                  :placeholder="$t('armature_class_armaturediametr')" 
                  v-model="selectedOptions.armaturediametr"
                  clearable>
                  <el-option v-for="option in dictionary.armaturediametr" :key="option.id" :label="option.name" :value="option.id">
                    </el-option>
                  </el-select>
                </div>
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('brick_or_stone_wall_type') }}
                  </label>
                  <el-select 
                  class="w-full" 
                  :placeholder="$t('brick_or_stone_wall_type')" 
                  v-model="selectedOptions.brick_or_stone_wall_type"
                  clearable>
                  <el-option v-for="option in 3" :key="option.id" :label="option" :value="option">
                    </el-option>
                  </el-select>
                </div>
                <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('mixture_class') }}
                  </label>
                  <el-select 
                  class="w-full" 
                  :placeholder="$t('mixture_class')" 
                  v-model="selectedOptions.mixture_class"
                  clearable>
                  <el-option v-for="option in dictionary.mixtureClasslist" :key="option.id" :label="option.name" :value="option.id">
                    </el-option>
                  </el-select>
                </div>
                <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('soil_type') }}
                  </label>
                  <el-select 
                  class="w-full" 
                  :placeholder="$t('soil_type')" 
                  v-model="selectedOptions.soil_type"
                  clearable>
                  <el-option v-for="option in dictionary.soiltype" :key="option.id" :label="option.name" :value="option.id">
                    </el-option>
                  </el-select>
                </div>
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('steel_resistance') }}
                  </label>
                  <el-input
                    v-model="selectedOptions.steel_resistance"
                    type="number"
                    :placeholder="$t('steel_resistance')"
                    clearable
                  />
                </div>
                <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                  <label class="block font-medium text-sm mb-2">
                    {{ $t('determination_endurance_reserve') }}
                  </label>
                  <el-input
                    v-model="selectedOptions.determination_endurance_reserve"
                    type="number"
                    :placeholder="$t('determination_endurance_reserve')"
                    clearable
                  />
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="advanced-filter-btn flex w-full justify-end mt-5">
        <div slot="footer" class="flex items-center justify-end gap-2">
          <button class="light-button" @click="dialogVisible = false">
            {{ $t('cancel') }}
          </button>
          <button class="primary-button" type="primary" @click="__GET()">
            {{ $t('search_btn') }}
            <h-search />
          </button>
        </div>
      </div>
    </el-dialog>



  </div>
  <ScletonPage v-else />
</template>

<script>
import ScletonPage from "./../components/Scletons/Page.vue";
import InvestmentSwitch from "@/components/InvestmentSwitch";
import BuildingUpgradeCadasterVue from './BuildingUpgradeCadaster.vue';
import HFilter07 from './Icons/hFilter07.vue';
import HRemoveCircle from './Icons/hRemoveCircle.vue';
import IconBuilding4 from './Icons/iconBuilding4.vue';
import HCompass from './Icons/hCompass.vue';
import HSearch from './Icons/hSearch.vue';
import HFileDownload from './Icons/hFileDownload.vue';
import HLoading from './Icons/hLoading.vue';
import HSertificate from './Icons/hSertificate.vue';
import HEdit from './Icons/hEdit.vue';
import HTrash from './Icons/hTrash.vue';
import HDocumentText from './Icons/hDocumentText.vue';
import HAddCircle from "./Icons/hAddCircle.vue";
import HEye from "./Icons/hEye.vue";
import HUser from '@/components/Icons/hUser.vue';
import HHome from '@/components/Icons/hHome.vue';
import HCall from '@/components/Icons/hCall.vue';
import HMail from '@/components/Icons/hMail.vue';
export default {
  components: {
    ScletonPage,
    InvestmentSwitch,
    BuildingUpgradeCadasterVue,
    HFilter07,
    HRemoveCircle,
    IconBuilding4,
    HCompass,
    HSearch,
    HFileDownload,
    HLoading,
    HSertificate,
    HEdit,
    HTrash,
    HDocumentText,
    HAddCircle,
    HEye,
        HUser,
        HHome,
        HCall,
        HMail,
  },
  data() {
    return {
      pdf: "",
      namePdf: "",
      loadDawer: false,
      districts: [],
      drawer: false,
      input2: null,
      page_count: 0,
      buildsList: [],
      region: "",
      district: "",
      neighborhood: "",
      neighborhoods: [],
      buildinggroup: "",
      current_district: [],
      loadingNeighborhood: false,
      objInfo: {},
      search: "",
      item_count: 10,
      loading: false,
      current_page: 1,
      current_page1: 1,
      buildingtype: "",
      usermodal: false,
      userData: {
        organization: {},
        profile: {},
      },
      nameRules: [],
      nameRulesDate: [],
      loading_generate: false,
      selectedOptions: {},
      options: [],
      placeholders: [
        {
          value: "reconstructiondurability",
          title: "building_reconstruction",
        },
        {
          value: "dailycondition",
          title: "passport_dailycondition",
        },
        {
          value: "dividedintosections",
          title:
            "divided_into_sections_input",
        },
        {
          value: "earthquakecondition",
          title:
            "earthquakecondition_input",
        },
      ],
      apiEndpoints: [
        "/dictionary/constructivesolution/",
        "/dictionary/plannedshape/",
        "/dictionary/buildingseismicity/",
        "/dictionary/reconstructiondurability/",
        "/dictionary/dailycondition/",
        "/dictionary/dividedintosections/",
        "/dictionary/loadbearing/",
        "/dictionary/earthquakecondition/",
        "/dictionary/foundationtype/",
      ],
      dialogVisible: true,
      newCadastrModal: false,
      newCasasterForm: {}
    };
  },
  watch: {
    "$route.params.type"() {
      if (this.$route.params.type == undefined) {
        if (
          this.me.role.name == "ministry" ||
          this.me.role.name == "ministry_admin" ||
          this.me.role.name == "main_org_admin"
        ) {
          this.$router.push("/building-list/new").catch((e) => {
            if (
              e.name !== "NavigationDuplicated" &&
              !e.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              console.log(e);
            }
          });
        } else {
          if (this.$route.path == "/unattested-building-list/") {
            this.$router.push("/unattested-building-list/exg").catch((e) => {
              if (
                e.name !== "NavigationDuplicated" &&
                !e.message.includes(
                  "Avoided redundant navigation to current location"
                )
              ) {
                console.log(e);
              }
            });
          } else if (this.$route.path == "/building-list/") {
            this.$router.push("/building-list/exg").catch((e) => {
              if (
                e.name !== "NavigationDuplicated" &&
                !e.message.includes(
                  "Avoided redundant navigation to current location"
                )
              ) {
                console.log(e);
              }
            });
          }
        }
      } else {
        this.__GET();
      }
    },
  },
  computed: {
    dictionary() {
      return this.$store.state.dictionary;
    },
    baseURL() {
      return axios.defaults.baseURL;
    },
    buildType() {
      let a = {
        exg: "Мавжуд",
        new: "Янги",
        newcadaster: "Кадастр рақами янгиланган"
      };

      return a[this.$route.params.type];
    },
    me() {
      return this.$store.state.me;
    },
    role() {
      return this.$store.state.role;
    },
    regions() {
      return this.$store.state.dictionary.region;
    },
    building_group() {
      return this.$store.state.dictionary.buildinggroup;
    },
  },
  created() {
    this.loading = true;
    this.apiEndpoints.forEach((endpoint, index) => {
      // this.fetchOptions(endpoint, index);
    });
    if (this.$route.params.type == undefined) {
      if (this.me.role.name == "ministry" || this.me.role.name == "ministry_admin" || this.me.role.name == "main_org_admin") {
        this.$router.push("/building-list/new").catch((e) => {
          if (
            e.name !== "NavigationDuplicated" &&
            !e.message.includes(
              "Avoided redundant navigation to current location"
            )
          ) {
            console.log(e);
          }
        });
      }
      else {
        if (this.$route.path == "/unattested-building-list/") {
          this.$router.push("/unattested-building-list/exg").catch((e) => {
            if (
              e.name !== "NavigationDuplicated" &&
              !e.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              console.log(e);
            }
          });
        }
        else if (this.$route.path == "/building-list/") {
          this.$router.push("/building-list/newcadaster").catch((e) => {
            if (
              e.name !== "NavigationDuplicated" &&
              !e.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              console.log(e);
            }
          });
        }
      }
    }
    else {
      this.current_page = this.$route.query.page
        ? parseInt(this.$route.query.page)
        : 1;
      this.search = this.$route.query.search ? this.$route.query.search : "";
      this.region = this.$route.query.region
        ? parseInt(this.$route.query.region)
        : "";
      this.district = this.$route.query.district
        ? parseInt(this.$route.query.district)
        : "";
      this.buildinggroup = this.$route.query.buildinggroup
        ? parseInt(this.$route.query.buildinggroup)
        : "";
      this.item_count = this.$route.query.item_count
        ? parseInt(this.$route.query.item_count)
        : 10;
      if (this.region != "") {
        this.getDistrict();
      }
      this.__GET();
    }
  },
  methods: {
    fetchOptions() {
      this.dialogVisible = true
      console.log('rrr')
      const data = [
        "constructivesolution",
        "plannedshape",
        "buildingseismicity",
        "reconstructiondurability",
        "dailycondition",
        "dividedintosections",
        "loadbearing",
        "earthquakecondition",
      ]
      data.forEach((option, _) => {
        const arr = []
        this.dictionary[option].forEach(elem => {
          arr.push({
            label: elem.name_cyr || elem.number,
            value: elem.id
          })
        })
        this.options.push(arr)
      })
    },
    GeneratePasport(id) {
      this.loading = true;
      axios
        .post(`/building/specification/${id}/generate/`)
        .then((res) => {
          if (res.data.success) {
            this.drawer = true;
            this.loadDawer = true;
            this.pdf = axios.defaults.baseURL.slice(0, -8) + res.data.pdf_link;
          }
        })
        .catch((e) => { })
        .finally(() => {
          this.loading = false;

          this.loadDawer = false;
        });
    },
    tableRowClassName({ row }) {
      if (row.finalconclusion > 2) {
        return "warning-row";
      }
      if (row.finalconclusion < 3) {
        return "success-row";
      }
    },
    paginate(val) {
      this.current_page = val;
      this.__GET();
    },
    paginateSize(val) {
      this.item_count = val;
      this.__GET();
    },
    __GET() {
      let type = this.$route.params.type.toUpperCase();
      let offset = this.item_count * (this.current_page - 1);
      const status = this.$route.query.status || 'approved';
      const query = {
        ...this.selectedOptions,
      };
      if (
        this.search != "" ||
        this.region != "" ||
        this.district != "" ||
        this.buildinggroup != "" ||
        this.item_count != 10
      ) {
        if (this.$route.path == "/unattested-building-list/") {
          this.$router
            .push({
              path: `/unattested-building-list/${this.$route.params.type}?page=${this.current_page}&region=${this.region}&district=${this.district}&buildinggroup=${this.buildinggroup}&item_count=${this.item_count}&search=${this.search}`,
              query: {
                ...query,
              },
            })
            .catch((e) => {
              if (
                e.name !== "NavigationDuplicated" &&
                !e.message.includes(
                  "Avoided redundant navigation to current location"
                )
              ) {
                console.log(e);
              }
            });
        }
        else {
          this.$router
            .push({
              path: `/building-list/${this.$route.params.type}?page=${this.current_page}&region=${this.region}&district=${this.district}&buildinggroup=${this.buildinggroup}&item_count=${this.item_count}&search=${this.search}`,
              query: {
                ...query,
              },
            })
            .catch((e) => {
              if (
                e.name !== "NavigationDuplicated" &&
                !e.message.includes(
                  "Avoided redundant navigation to current location"
                )
              ) {
                console.log(e);
              }
            });
        }
      }
      else {
        if (this.$route.path == `/unattested-building-list/${this.$route.params.type}`) {
          this.$router
            .push({
              path: `/building-list/${this.$route.params.type}`,
              query: {
                page: this.current_page,
                ...query,
              },
            })
            .catch((e) => {
              if (
                e.name !== "NavigationDuplicated" &&
                !e.message.includes(
                  "Avoided redundant navigation to current location"
                )
              ) {
                console.log(e);
              }
            });
        } else {
          this.$router
            .push({
              path: `/building-list/${this.$route.params.type}`,
              query: {
                page: this.current_page,
                ...query,
              },
            })
            .catch((e) => {
              if (
                e.name !== "NavigationDuplicated" &&
                !e.message.includes(
                  "Avoided redundant navigation to current location"
                )
              ) {
                console.log(e);
              }
            });
        }
      }
      if (this.$route.path == "/unattested-building-list/exg") {
        let params = {
          list: (this.role == "admin" || this.role == "supervisor") ? 'selectionforadmin' : '',
          buildingtype: type,
          search: this.search,
          region__shared_id: this.region,
          district: this.district,
          building_group: this.buildinggroup,
          limit: this.item_count,
          offset: offset,
          status: status,
        }
        axios
          .get(
            `/building/specificationlist/`,
            {
              params: params
            }
          )
          .then((response) => {
            console.log(response.data);

            this.buildsList = response.data.results;
            this.page_count = Math.ceil(response.data.count / this.item_count);
            this.current_page1 = this.$route.query.page
              ? parseInt(this.$route.query.page)
              : parseInt(this.$route.query.page);
          })
          .finally(() => {
            this.loading = false;
          });
      }
      else if (this.$route.path == "/unattested-building-list/new") {
        let params = {
          list: (this.role == "admin" || this.role == "supervisor") ? 'selectionforadmin' : '',
          buildingtype: type,
          search: this.search,
          region__shared_id: this.region,
          district: this.district,
          building_group: this.buildinggroup,
          limit: this.item_count,
          offset: offset,
          status: status,
        }
        axios
          .get(
            `/building/specificationlist/`,
            {
              params: params
            }
          )
          .then((response) => {
            this.buildsList = response.data.results;
            this.page_count = Math.ceil(response.data.count / this.item_count);
            this.current_page1 = this.$route.query.page
              ? parseInt(this.$route.query.page)
              : parseInt(this.$route.query.page);
          })
          .finally(() => {
            this.loading = false;
          });
      }
      else {
        let params = {
          list: (this.role == "admin" || this.role == "supervisor") && this.$route.path == `/building-list/${this.$route.params.type}` ? 'selectionforadmin' : '',
          buildingtype: type,
          search: this.search,
          region__shared_id: this.region,
          district: this.district,
          building_group: this.buildinggroup,
          limit: this.item_count,
          offset: offset,
          status: status,
          ...query
        }
        if ((this.role == "admin" || this.role == "supervisor") && this.$route.path == `/building-list/${this.$route.params.type}`) {
          params.list = 'selectionforadmin'
        }
        if (this.$route.params.type == 'newcadaster') {
          params.buildingtype = ['ministry_admin', 'ministry', 'main_org_admin'].includes(this.role) ? 'NEW' : 'EXG'
          params.type = 'new'
          delete params.status
        }

        axios
          .get(`/building/specificationlist/`, { params: params })
          .then((response) => {

            this.buildsList = response.data.results;
            this.page_count = Math.ceil(response.data.count / this.item_count);
            this.current_page1 = this.$route.query.page
              ? parseInt(this.$route.query.page)
              : parseInt(this.$route.query.page);
          })
          .finally(() => {
            this.loading = false;
          });
      }
      this.dialogVisible = false;
    },
    routeTo(item, a) {
      if (item.buildingtype === "NEW") {
        this.$router
          .push({
            path: `/new-build/${item.id}/${a}`,
            params: {
              id: this.$route.params.id,
            },
            query: {
              id: item.id,
            },
          })
          .catch((e) => {
            if (
              e.name !== "NavigationDuplicated" &&
              !e.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              console.log(e);
            }
          });
      } else {
        this.$router
          .push({
            path: `/exist-build/${item.id}/${a}`,
            params: {
              id: this.$route.params.id,
            },
            query: {
              id: item.id,
            },
          })
          .catch((e) => {
            if (
              e.name !== "NavigationDuplicated" &&
              !e.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              console.log(e);
            }
          });
      }
    },
    regionChanged() {
      this.current_page = 1;
      this.current_page1 = 1;
      if (
        this.search != "" ||
        this.region != "" ||
        this.district != "" ||
        this.buildinggroup != "" ||
        this.item_count != 10
      ) {
        this.$router
          .push(
            `/building-list/${this.$route.params.type}?page=${this.current_page}&region=${this.region}&district=${this.district}&buildinggroup=${this.buildinggroup}&item_count=${this.item_count}&search=${this.search}`
          )
          .catch((e) => {
            if (
              e.name !== "NavigationDuplicated" &&
              !e.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              console.log(e);
            }
          });
      } else {
        this.$router
          .push(
            `/building-list/${this.$route.params.type}?page=${this.current_page}`
          )
          .catch((e) => {
            if (
              e.name !== "NavigationDuplicated" &&
              !e.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              console.log(e);
            }
          });
      }
      this.districts = [];
      this.district = "";
      this.getDistrict();
    },
    getDistrict() {
      this.loading = true;
      axios
        .get(`/dictionary/district/?region__shared_id=${this.region}`)
        .then((response) => {
          this.districts = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getNeighborhoods() {
      this.loadingNeighborhood = false
      this.neighborhood = ""
      this.neighborhood = []
      axios.get(`/dictionary/neighborhood/?district__shared_id=${this.district}`)
      .then((response) => {
        this.neighborhoods = response.data
      }).finally(() => {
        this.loadingNeighborhood = false
      })
    },
    ChangeDistrict() {
      this.current_page = 1;
      this.current_page1 = 1;
      if (
        this.search != "" ||
        this.region != "" ||
        this.district != "" ||
        this.buildinggroup != "" ||
        this.item_count != 10
      ) {
        this.$router.push(
          `/building-list/${this.$route.params.type}?page=${this.current_page}&region=${this.region}&district=${this.district}&buildinggroup=${this.buildinggroup}&item_count=${this.item_count}&search=${this.search}`
        );
      } else {
        this.$router.push(
          `/building-list/${this.$route.params.type}?page=${this.current_page}`
        );
      }
    },
    DownloadExel(id, name) {
      axios({
        url: `/building/generate/${id}/building/`,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", `${name}-Bino-${id}.xlsx`);
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    },
    downloadFile(file) {
      fetch(file)
        .then((resp) => resp.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          // the filename you want
          a.download = "PasportBino" || "file.json";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        });
    },
    UserModal(a) {
      if (a != null && a.profile != null) {
        this.userData = a;
        this.usermodal = true;
      }
    },
    deleteBuilding(id) {
      return this.$confirm(`Сиз ростдан ҳам ушбу бинони ўчирмоқчимисиз?`, {
        confirmButtonText: "Ҳа",
        cancelButtonText: "Йўқ",
      }).then(() => {
        axios
          .delete(`/building/buildingdestroy/${id}/`)
          .then((response) => {
            this.$swal.fire({
              icon: "success",
              title: "Қониқарли. Бинони учирилди",
              timer: 3000,
            });
            this.__GET();
          })
          .catch((error) => {
            this.$swal.fire({
              icon: "error",
              title: "Бинони учиришда хатолик",
              timer: 3000,
            });
          });
      });
    },
    generate_building_list() {
      this.loading_generate = true;
      let type = this.$route.params.type.toUpperCase();
      let offset = this.item_count * (this.current_page - 1);
      axios({
        url: `/building/generate_building_info/?buildingtype=${type}&search=${this.search}&region__shared_id=${this.region}&district=${this.district}&building_group=${this.buildinggroup}&limit=${this.item_count}&offset=${offset}`,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", `Bino-1.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .finally(() => {
          this.loading_generate = false;
        });
    },
    setNewCadasterFrom(item) {
      this.newCadastrModal = true
      this.newCasasterForm = item
    }
  },
};
</script>

<style lang="scss">
.top-header {
  margin-bottom: 20px;
}

.h-full {
  height: 100%;
}

.df {
  display: flex;
}

.jcsb {
  justify-content: space-between;
}

.jcc {
  justify-content: center;
}

.aic {
  align-items: center;
}

.advanced-filter-select {
  width: 450px !important;
}

.advanced-filter-wrap {
  .el-dialog__wrapper {
    .el-dialog {
      border-radius: 10px;

      @media screen and (max-width:1760px) {
        width: 823px !important;
      }

      @media screen and (max-width:1770px) {
        .el-dialog__body {
          .advanced-filter-input {
            div {

              div {
                label {
                  font-size: 12px;
                }

                .el-select {
                  width: 350px !important;
                }

                .el-date-editor {
                  width: 350px !important;
                }
              }
            }
          }
        }
      }
    }
  }
}

.advanced-filter {
  background: linear-gradient(141.56deg,
      #96e9f4 -17.15%,
      #3730A3 100%) !important;
  color: #fff !important;
  font-weight: 600;
}
.filter{
  .el-collapse{
    border: none !important;
  }
  .el-collapse-item__header{
    border-radius: 16px !important;
    padding-left: 16px !important;
    border: none !important;
    color: #94A3B8;
    
  }
  .el-collapse-item__header.is-active{
    background: transparent !important;
    padding-left: 0 !important;
    color: #020617;
  }
  .el-collapse-item__wrap{
    border: none !important;
    border-radius: 20px;
    margin-top: 20px;

  }
  .el-collapse-item__content{
    padding: 0 !important;
  }
}

</style>
